"use client";

import React from "react";
import Image from "next/image";
import Link from "next/link";
import { MapPin, Phone, Clock, Mail } from "lucide-react";

export function Footer() {
  const navLinks = [
    { label: "Услуги", href: "/uslugi/" },
    { label: "Портфолио", href: "/portfolio/" },
    { label: "О компании", href: "/o-kompanii/" },
    { label: "Как заказать", href: "/kak-rabotaem/" },
    { label: "Политика конфиденциальности", href: "/politika-konfidencialnosti/" },
  ];

  return (
    <footer id="contacts" className="border-t border-slate-200 dark:border-slate-800 bg-white dark:bg-[#07090F] pt-16 pb-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
          <div className="rounded-xl p-6 border border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/40 flex flex-col justify-between">
            <div>
              <div className="flex items-center gap-2.5 mb-4">
                <div className="relative w-7 h-7 shrink-0">
                  <Image
                    src="/images/logo-icon.png"
                    alt="Альянс-Дизайн"
                    fill
                    sizes="28px"
                    className="object-contain"
                  />
                </div>
                <span className="font-semibold text-lg text-slate-900 dark:text-white">
                  Альянс-Дизайн
                </span>
              </div>
              <p className="text-sm text-slate-600 dark:text-slate-300 leading-relaxed">
                Рекламно-производственная компания полного цикла. Собственная база широкоформатной печати, фрезеровки и наружной рекламы в Республике Коми.
              </p>
            </div>

            <div className="mt-6 pt-4 border-t border-slate-200/60 dark:border-slate-800/60 text-xs font-mono text-slate-400 flex items-center justify-between">
              <span>Сыктывкар</span>
              <span>Работаем с 2014 года</span>
            </div>
          </div>

          <div className="rounded-xl p-6 border border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/40 flex flex-col justify-between">
            <div>
              <span className="text-xs font-mono text-slate-400 block mb-2">Контакты производства</span>
              <a
                href="tel:88001234567"
                className="text-xl font-semibold text-slate-900 dark:text-white hover:text-[#0a3d90] dark:hover:text-[#3b82f6] transition-colors block mb-4"
              >
                8 800 123-45-67
              </a>

              <div className="space-y-2.5 text-xs text-slate-600 dark:text-slate-300">
                <div className="flex items-start gap-2">
                  <MapPin className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                  <span>г. Сыктывкар, ул. Индустриальная, 20/6</span>
                </div>
                <div className="flex items-start gap-2">
                  <Clock className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                  <span>Пн-Пт: 09:00 — 19:00, Сб: 10:00 — 16:00</span>
                </div>
                <div className="flex items-start gap-2">
                  <Mail className="w-3.5 h-3.5 text-slate-400 shrink-0 mt-0.5" />
                  <span>info@alyans-design.ru</span>
                </div>
              </div>
            </div>

            <div className="mt-6 pt-4 border-t border-slate-200/60 dark:border-slate-800/60 text-xs font-mono text-slate-500">
              Безналичный расчет с НДС 20%
            </div>
          </div>

          <div className="rounded-xl p-6 border border-slate-200 dark:border-slate-800 bg-slate-50/50 dark:bg-slate-900/40 flex flex-col justify-between">
            <div>
              <span className="text-xs font-mono text-slate-400 block mb-2">Отдел по работе с клиентами</span>
              <p className="text-sm font-medium text-slate-900 dark:text-white mb-2">
                Консультация технолога и выезд на замер
              </p>
              <p className="text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
                Выезжаем на объект с образцами материалов и лазерным дальномером. Поможем составить ТЗ и рассчитаем смету.
              </p>
            </div>

            <div className="mt-6 pt-4 border-t border-slate-200/60 dark:border-slate-800/60 flex items-center justify-between text-xs text-slate-600 dark:text-slate-300 font-mono">
              <span>Диадок / СБИС</span>
              <span>ЭДО подключен</span>
            </div>
          </div>
        </div>

        <div className="pt-6 border-t border-slate-200/80 dark:border-slate-800/80 flex flex-col md:flex-row items-center justify-between gap-4 text-xs text-slate-500 dark:text-slate-400">
          <div>
            © 2026 ООО «Альянс-Дизайн». Все права защищены.
          </div>

          <div className="flex flex-wrap items-center gap-5">
            {navLinks.map((link) => (
              <Link
                key={link.label}
                href={link.href}
                className="hover:text-slate-900 dark:hover:text-white transition-colors"
              >
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}
